import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CallService } from '../../core/call-service/browser/call.service';
import { LogService } from '../../core/log/log.service';
import { getCategoriesUrl } from '../../core/router/routes-provider';
import { Category } from './category.model';

@Injectable({ providedIn: 'root' })
export class CategoryService {
	constructor(private callService: CallService, private logService: LogService) {}

	loadCategory(): Observable<Category[]> {
		const urltoCall = getCategoriesUrl();
		this.logService.info('Calling ', urltoCall);
		const result = this.callService.CallApiList<Category>('GET', urltoCall);
		return result;
	}
}
